<template>
  <div :class="[`button-see-all`, className || ``]">
    <div class="text-14 roboto-medium-azure-radiance-24px-2">ПОДРОБНЕЕ</div>
    <img
      class="vector-20"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d960dd33287fc8c76d6b57/img/vector-20-2.svg"
      alt="Vector 20"
    />
  </div>
</template>

<script>
export default {
  name: "ButtonSeeAll",
  props: ["className"],
};
</script>

<style>
.button-see-all {
  height: 39px;
  left: 1625px;
  position: absolute;
  top: 0;
  width: 218px;
}

.text-14 {
  left: 0;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: calc(50% - 14px);
  white-space: nowrap;
  width: 65.6%;
}

.vector-20 {
  height: 32px;
  left: 191px;
  position: absolute;
  top: 5px;
  width: 34px;
}

.button-see-all.button-see-all-1 {
  left: 1616px;
  top: 2px;
}

.button-see-all.button-see-all-1 .vector-20 {
  top: 4px;
}
</style>
